import '@ant-design/compatible/assets/index.css';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import PropertiesBulkOperationModal from './modal';

@modal(
  {
    className: 'properties-bulk-operation-modal',
  },
  true,
)
class PropertiesBulkOperationContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { selectedProperties, bulkOperation } = this.props;

    return (
      <PropertiesBulkOperationModal
        selectedProperties={selectedProperties}
        bulkOperation={bulkOperation}
        onClose={this.props.handleCloseModal}
        onSuccess={this.props.onSuccess}
        unpublishReason={this.props.unpublishReason}
      />
    );
  }
}

PropertiesBulkOperationContainer.propTypes = {
  t: PropTypes.func.isRequired,
  selectedProperties: PropTypes.array.isRequired,
  bulkOperation: PropTypes.string.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  unpublishReason: PropTypes.string.isRequired,
};

PropertiesBulkOperationContainer.defaultProps = {
  t: () => {},
  selectedProperties: [],
  bulkOperation: '',
  handleCloseModal: () => {},
  onSuccess: () => {},
  unpublishReason: () => {},
};

export default PropertiesBulkOperationContainer;
